/**
 * Data Room Module
 *
 * Complete data room management with document tracking,
 * progress calculation, and methodology integration.
 */

// Types
export * from './types';

// Data
export { DATA_ROOM_DOCUMENTS, getDocumentsByCategory, getDocumentsByDimension, getDocumentsForStage, getRecommendedDocumentsForStage } from './documents';

// Store
export { useDataRoomStore } from './store';

// Domains
export { DOMAIN_LABELS, DOMAIN_DOCUMENTS, getDomainDocuments, getRequiredDomainDocuments, getOptionalDomainDocuments } from './domains';
export type { StartupDomain, DomainDocument } from './domains';

// Document Mapping
export { DOCUMENT_COVERAGE_MAP, UPLOADED_DOCUMENT_LABELS, getChecklistItemsCovered, suggestDocumentType } from './document-mapping';
export type { UploadedDocumentType, UploadedDocument } from './document-mapping';

// Utilities
export {
  calculateCategoryProgress,
  calculateDimensionCoverage,
  calculateProgress,
  calculateScoreImpact,
  computeDealReadiness,
  getConfidenceMultiplier,
  getFilteredDocuments,
  getRequirementColor,
  getRequirementLabel,
  getStatusColor,
  getStatusLabel,
  getSuggestedDocuments,
  isDocumentApplicable,
  isDocumentRequired,
} from './utils';
export type { DealReadiness, DealReadinessDoc } from './utils';
